jQuery(document).ready(function ($) {
    let buffer = false;

    $('.js-hamburger').on('click', function (event) {
        if (buffer) { return; }

        buffer = true;

        $(this).toggleClass('open');
        $('body').toggleClass('on-nav')

        setTimeout(function () {
            buffer = false;
        }, 500);
    });
});